// js/invenio_app_rdm/landing_page/RecordTemplateButton.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";
import { http } from "react-invenio-forms";

export const RecordTemplateButton = ({ pid, endpoint }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onClick = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await http.post(
        endpoint || `/api/records/${pid}/template`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const draftHtml = res?.data?.links?.self_html;
      const draftId = res?.data?.id;

      window.location.href = draftHtml || `/uploads/${draftId}`;
    } catch (e) {
      console.error(e);
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.errors?.[0]?.message ||
        "Failed to create draft from template.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button className="left labeled icon positive fluid" onClick={onClick} loading={loading} disabled={loading}>
        <Icon name="copy" />
        Use as template
      </Button>

      {error && (
        <div className="ui negative message mt-10">
          <div className="header">Error</div>
          <p>{error}</p>
        </div>
      )}
    </>
  );
};

RecordTemplateButton.propTypes = {
  pid: PropTypes.string.isRequired,
  endpoint: PropTypes.string,
};
